export const INVOICE_STRINGS = {
  panNo: "AUWPV4858K",
  statutoryGuidelines: [
    "1. PAN No.: AUWPV4858K",
    "2. Payment Should be made ONLY by crossed cheque or DD in favour of THE CYBERINTEL after obtaining tax invoice positively OR NEFT to designated account OR pay with UPI using given QR Code.",
    "3. PAYMENT DUE DATE: ",
    "4. Any delay in payment after due date : will be charged 24% per annum on prorata basis.",
  ],
  generalGuidelines: [
    "1. Kindly acknowledge the receipt of the bill by handing over the bill acknowledgement. Duly filled up. To our representive who delivers the bill to you.",
    "2. While making the payment please handover the payment advice with full details.",
    "3. Any mistakes/correction found in the invoice has to be reported in writing within 7 days from the receipt of the invoice.",
    "4. This is a computer-generated invoice and hence does not require signature.",
    "5. For any queries please mail to contact@thecyberintel.com.",
  ],
  bankDetails: {
    beneficiaryName: "The Cyberintel",
    bankName: "HDFC Bank Ltd.",
    accountNo: "50200103165773",
    accountType: "Current Account",
    ifsc: "HDFC0000601",
  },
  paymentAdviceHeader: "Payment Advice (Please detach and return with your payment)",
  billAcknowledgementHeader: "BILL ACKNOWLEDGEMENT",
  channelPartnerText: "Channel Partner of DTDC Express Limited",
  summaryHeader: "SUMMARY",
  websiteUrl: "www.thecyberintel.com",
  contactEmail: "contact@thecyberintel.com",
};

export const INVOICE_TABLE_HEADERS = {
  summary: ["S.No", "Docket No", "Date", "Destination", "Mode", "Weight", "Amount"],
  paymentAdvice: ["Bank Name", "Cheque/DD/Ref. No.", "Payment Date", "Invoice Amount", "TDS", "Net Amount"],
};
